import React from 'react';
import CoursePackage from '@/components/CoursePackage';

const CoursePackageBlock = () => {
  const config = [
    {
      packageName: '课程包-课时-1-课包名',
      hoursClass: '课程包-课时-1-课时',
      price: '课程包-课时-1-价格',
      btnName: '课程包-按钮',
      description: '课程包-课时-1-描述',
      id: '1',
      ga: 'BasicCourseCTAClick',
    },
    {
      packageName: '课程包-课时-2-课包名',
      hoursClass: '课程包-课时-2-课时',
      price: '课程包-课时-2-价格',
      btnName: '课程包-按钮',
      description: '课程包-课时-2-描述',
      label: '课程包-标签1',
      id: '2',
      ga: 'RegularCourseCTAClick',
    },
    {
      packageName: '课程包-课时-3-课包名',
      hoursClass: '课程包-课时-3-课时',
      price: '课程包-课时-3-价格',
      btnName: '课程包-按钮',
      description: '课程包-课时-3-描述',
      label: '课程包-标签2',
      id: '3',
      ga: 'ValuePackCTAClick',
    },
  ];

  return (
    <section className="marginModelTop">
      <CoursePackage
        subject="english"
        config={config}
        blockSubTitle="课程包-副标题"
        blockTitle="课程包-标题"
        useTranslationName="english"
      />
    </section>
  );
};

export default CoursePackageBlock;
